import {useSyncExternalStore} from 'react';
import pt from './pt-BR.json';
const key='loop-interface-language-v1';
let transientLanguage = null;
export const LANGUAGE_EVENT='loop-language-changed';
export const languages=[{code:'es',name:'Español'},{code:'pt-BR',name:'Português (Brasil)'}];
export function savedLanguage(){try{const value=localStorage.getItem(key);return languages.some(l=>l.code===value)?value:null;}catch(_){return transientLanguage;}}
export function normalizeLanguage(value){return /^pt(?:[-_]|$)/i.test(String(value||''))?'pt-BR':'es';}
export function getLanguage(){
 try {const saved=localStorage.getItem(key);if(languages.some(l=>l.code===saved))return saved;}catch(_){if(transientLanguage)return transientLanguage;}
 return normalizeLanguage(typeof navigator==='undefined'?'es':navigator.language);
}
export function setLanguage(value,{persistAccount=true}={}){
 const language=normalizeLanguage(value);
 try{localStorage.setItem(key,language);transientLanguage=null;}catch(_){transientLanguage=language;}
 document.documentElement.lang=language;
 window.dispatchEvent(new CustomEvent(LANGUAGE_EVENT,{detail:{language,persistAccount}}));
 return language;
}
function subscribe(callback){window.addEventListener(LANGUAGE_EVENT,callback);window.addEventListener('storage',callback);return()=>{window.removeEventListener(LANGUAGE_EVENT,callback);window.removeEventListener('storage',callback);};}
export function useLanguage(){return useSyncExternalStore(subscribe,getLanguage,()=> 'es');}
export function t(source,values={},language=getLanguage()){
 const original=String(source ?? '');
 const message=language==='pt-BR'&&Object.prototype.hasOwnProperty.call(pt,original)?pt[original]:original;
 return message.replace(/\{(\w+)\}/g,(whole,name)=>Object.prototype.hasOwnProperty.call(values,name)?String(values[name]):whole);
}
export function interfaceLocale(){return getLanguage()==='pt-BR'?'pt-BR':'es-PA';}
